module.exports = __webpack_public_path__ + "static/media/ps.ce1017e9.svg";